
      $(document).ready(function() {
        $('#lightSliderRezept').lightSlider({
            gallery:true,
            controls: false,
            item:1,
            loop:true,
            thumbItem:6,
            slideMargin:0,
            adaptiveHeight:true,
            enableDrag: false,
            currentPagerPosition:'left',
        });  

         $('#lightSliderProduct').lightSlider({
            gallery:true,
            controls: true,
            item:1,
            loop:true,
            thumbItem:6,
            slideMargin:0,
            adaptiveHeight:true,
            enableDrag: true,
            currentPagerPosition:'left',
        });  


         $('.scroll-link').on('click', function(e){
            e.preventDefault();
            var target = $('.productlist');
            if(target.length) {
        
                var scrollToPosition = target.offset().top - 120;

                $('html, body').animate({
                    scrollTop: scrollToPosition
                }, 1000);
            }
        });
      });
